import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HookHandlerClass;
function HookHandler() {
  if (HookHandlerClass === VOID) {
    class $ {
      constructor(hook, handler) {
        this.c5u_1 = hook;
        this.d5u_1 = handler;
      }
      q5g(client) {
        this.c5u_1.f5m(client, this.d5u_1);
      }
    }
    initMetadataForClass($, 'HookHandler');
    HookHandlerClass = $;
  }
  return HookHandlerClass;
}
//region block: exports
export {
  HookHandler as HookHandler356pvj77mag23,
};
//endregion

//# sourceMappingURL=ClientHook.mjs.map
